import { useState, useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalKey, ModalContext } from 'components/Modals/ModalContext'
import { useNavigate } from 'react-router-dom'
import { ChevronUpDownIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { ff, flags } from 'functions/roleBasedAccessUtils'
import trainingPeaksAppIcon from 'media/integrations/training_peaks/TrainingPeaks_App_Icon.jpg'

import UserProfilePicture from 'components/User/UserProfilePicture'
import OutlineButton from 'components/Buttons/OutlineButton'

export default function AthleteProfileListItem({ athlete, coaches, displayCoach = true, openProfileInNewTab = false }) {
    const navigate = useNavigate()

    const { ShowModal } = useContext(ModalContext)

    const userType = useSelector((state) => state.user.type)

    const canAssignTrainer = ff(flags.canAssignTrainer, { userType: userType })

    const [hideBackgroundHoverColor, setHideBackgroundHoverColor] = useState(false)

    const GetCoachName = (coachId) => {
        if (coachId === null) return 'No Coach'

        const coach = coaches.find(coach => coach.id === coachId)
        return coach ? `Coached By ${coach.firstName} ${coach.lastName.charAt(0).toUpperCase()}.` : 'No Coach'
    }

    const GetTrainingPeaksMappingAssignerCoachName = (trainingPeaksMappingAssignerCoachId) => {
        if (trainingPeaksMappingAssignerCoachId === null) return 'TrainingPeaks account connected'

        const coach = coaches.find(coach => coach.id === trainingPeaksMappingAssignerCoachId)
        return coach ? `TrainingPeaks account connected by ${coach.firstName} ${coach.lastName.charAt(0).toUpperCase()}.` : 'TrainingPeaks account connected'
    }

    const ShowAthleteCoachAssignmentModal = (e) => {
        
        e.stopPropagation()

        const modalData = {
            key: ModalKey.AssignTrainer,
            fullscreen: false,
            size: 'third',
            athleteId: athlete.id,
            organizationTrainerId: athlete.organizationTrainerId,
            athleteName: `${athlete.firstName} ${athlete.lastName}`,
        }

        ShowModal(modalData)
    
    }

    const OnAthletePressed = () => {
        if (openProfileInNewTab) {
            window.open(`/athlete/${athlete.id}`, '_blank')
        } else {
            navigate(`/athlete/${athlete.id}`)
        }
    }

    return (
        <li 
            className={`
                w-full flex items-center px-6 py-4 gap-x-6 cursor-pointer
                ${hideBackgroundHoverColor ? '' : 'hover:bg-gray-50'} 
            `}
            onClick={OnAthletePressed}
        >
            <UserProfilePicture firstName={athlete.firstName} lastName={athlete.lastName} shadow={false} />

            <div className="flex-grow">
                <p className="font-lg font-semibold">{athlete.firstName} {athlete.lastName}</p>
                
                {athlete.email.length > 0 && <p className="text-sm text-gray-600">{athlete.email}</p>}
                {athlete.email.length === 0 && <p className="text-sm text-gray-600">No Email</p>}
            </div>
            
            {athlete.trainingPeaksUserId.length > 0 &&
                <div 
                    className="relative group"
                    onMouseEnter={() => setHideBackgroundHoverColor(true)}
                    onMouseLeave={() => setHideBackgroundHoverColor(false)}
                    onClick={(e) => { e.stopPropagation(); }} // TODO: Open TrainingPeaks Athlete Calendar in new tab?
                >
                    <img 
                        src={trainingPeaksAppIcon}
                        alt="TrainingPeaks App Icon" 
                        className="h-8 w-8 rounded-md" 
                    />

                    <div className="absolute right-full top-1/2 transform -translate-y-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-10">
                        {GetTrainingPeaksMappingAssignerCoachName(athlete.trainingPeaksMappingAssignerCoachId)}
                    </div>
                </div>
            }

            {displayCoach && canAssignTrainer && (
                <div 
                    className='w-72 relative'
                    onMouseEnter={() => setHideBackgroundHoverColor(true)}
                    onMouseLeave={() => setHideBackgroundHoverColor(false)}
                >
                    <OutlineButton
                        text={GetCoachName(athlete.organizationTrainerId)}
                        className='hover:bg-gray-50'
                        action={(e) => ShowAthleteCoachAssignmentModal(e)}
                    />

                    <ChevronUpDownIcon 
                        className="absolute top-2.5 right-3 text-gray-400 h-5 w-5" 
                        onClick={(e) => ShowAthleteCoachAssignmentModal(e)}
                    />
                </div>
            )}

            <ChevronRightIcon className="text-gray-400 h-8" />
        </li>
    )
}